import styles from './style.module.scss'
import PropTypes from 'prop-types'

function SeparatorCommon({ separatorWord }) {
  return (
        <div className={`${styles.separator} small-head`}>{separatorWord}</div>
  )
}

export default SeparatorCommon

SeparatorCommon.propTypes = {
  separatorWord: PropTypes.string
}
